export const SnapshotType = {
  OPEN: 'open',
  CLOSED: 'closed'
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type SnapshotType = typeof SnapshotType[keyof typeof SnapshotType];

export const ErrorType = {
  GEO: 'geo',
  GENERIC: 'generic',
  OVERLIMIT: 'overlimit',
  WINDOW: 'window',
  FB_PERMISSIONS: 'fbPermissions',
  FB_GENERIC: 'fbGeneric',
  APPLE_PRIVATE_RELAY: 'apr',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type ErrorType = typeof ErrorType[keyof typeof ErrorType];
